// extracted by mini-css-extract-plugin
export default {"txt":"expandable-text_txt__OBbxG","expanded_txt":"expandable-text_expanded_txt__gtdpU","hidden":"expandable-text_hidden__Nxm1f","shown":"expandable-text_shown__i5h9Y"};